import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import FormRow from '../../../../components/FormRow';
import InputHandler from '../../../../components/InputHandler';
import { Container, Item } from 'Components/Grid';
import colors from '../../../../config/theme/colors';

interface IAppointmentFormProps {
  data: Partial<IAppointment> | null;
  changeData: (values: TOnChangeValues) => void;
}

const AppointmentForm = ({ data, changeData }: IAppointmentFormProps): React.JSX.Element => {
  return (
    <>
      <FormRow title="appointments.startDate">
        <InputHandler
          type="PartialDate"
          name="startDate"
          editing={true}
          formData={{
            onChange: changeData,
            document: { startDate: data?.startDate },
          }}
        />
      </FormRow>
      <FormRow title="appointments.startTime">
        <InputHandler
          type="TimePicker"
          name="startTime"
          editing={true}
          formData={{
            onChange: changeData,
            document: { startTime: data?.startTime },
          }}
        />
      </FormRow>
      <FormRow title="appointments.status">
        <InputHandler
          type="Select"
          name="status"
          editing={true}
          formData={{
            onChange: changeData,
            document: { status: data?.status },
          }}
          options={['booked', 'canceled', 'no-show', 'completed']}
          optionFormatter={(o): React.JSX.Element => <FormattedMessage id={`appointments.opts.${o}`} />}
          placeholder="appointments.statusPlaceholder"
        />
      </FormRow>
      <FormRow title="appointments.externalAppointmentType">
        <InputHandler
          type="TextField"
          name="externalAppointmentType"
          editing={true}
          formData={{
            onChange: changeData,
            document: {
              externalAppointmentType: data?.externalAppointmentType,
            },
          }}
          placeholder="appointments.externalAppointmentTypePlaceholder"
        />
      </FormRow>

      <FormRow title="appointments.locationGroup.title">
        <Container>
          <Item xs={4}>
            <div style={{ color: colors.darkGray }}>
              <FormattedMessage id="appointments.locationGroup.id" />
            </div>
            <InputHandler
              type="TextField"
              name="locationGroupId"
              editing={true}
              formData={{
                onChange: changeData,
                document: {
                  locationGroupId: data?.locationGroupId,
                },
              }}
              placeholder="appointments.idPlaceholder"
            />
          </Item>
          <Item xs={7}>
            <div style={{ color: colors.darkGray }}>
              <FormattedMessage id="appointments.locationGroup.name" />
            </div>
            <InputHandler
              type="TextField"
              name="locationGroupName"
              editing={true}
              formData={{
                onChange: changeData,
                document: {
                  locationGroupName: data?.locationGroupName,
                },
              }}
              fullWidth
              placeholder="appointments.namePlaceholder"
            />
          </Item>
        </Container>
      </FormRow>

      <FormRow title="appointments.locationType.title">
        <Container>
          <Item xs={4}>
            <div style={{ color: colors.darkGray }}>
              <FormattedMessage id="appointments.locationType.id" />
            </div>
            <InputHandler
              type="TextField"
              name="locationTypeId"
              editing={true}
              formData={{
                onChange: changeData,
                document: {
                  locationTypeId: data?.locationTypeId,
                },
              }}
              placeholder="appointments.idPlaceholder"
            />
          </Item>
          <Item xs={7}>
            <div style={{ color: colors.darkGray }}>
              <FormattedMessage id="appointments.locationType.text" />
            </div>
            <InputHandler
              type="TextArea"
              name="locationTypeText"
              editing={true}
              formData={{
                onChange: changeData,
                document: {
                  locationTypeText: data?.locationTypeText,
                },
              }}
              fullWidth
              rows={3}
              placeholder="appointments.textPlaceholder"
            />
          </Item>
        </Container>
      </FormRow>

      <FormRow title="appointments.location.title">
        <Container>
          <Item xs={4}>
            <div style={{ color: colors.darkGray }}>
              <FormattedMessage id="appointments.location.id" />
            </div>
            <InputHandler
              type="TextField"
              name="locationId"
              editing={true}
              formData={{
                onChange: changeData,
                document: {
                  locationId: data?.locationId,
                },
              }}
              placeholder="appointments.idPlaceholder"
            />
          </Item>
          <Item xs={7}>
            <div style={{ color: colors.darkGray }}>
              <FormattedMessage id="appointments.location.name" />
            </div>
            <InputHandler
              type="TextField"
              name="locationName"
              editing={true}
              formData={{
                onChange: changeData,
                document: {
                  locationName: data?.locationName,
                },
              }}
              fullWidth
              placeholder="appointments.namePlaceholder"
            />
          </Item>
        </Container>
      </FormRow>

      <FormRow title="appointments.endDate">
        <InputHandler
          type="PartialDate"
          name="endDate"
          editing={true}
          formData={{
            onChange: changeData,
            document: { endDate: data?.endDate },
          }}
        />
      </FormRow>
      <FormRow title="appointments.endTime">
        <InputHandler
          type="TimePicker"
          name="endTime"
          editing={true}
          formData={{
            onChange: changeData,
            document: { endTime: data?.endTime },
          }}
        />
      </FormRow>
      <FormRow title="appointments.comments">
        <InputHandler
          type="TextArea"
          name="comments"
          editing={true}
          formData={{
            onChange: changeData,
            document: { comments: data?.comments },
          }}
          placeholder="appointments.commentsPlaceholder"
        />
      </FormRow>
    </>
  );
};

export default AppointmentForm;
